import React, { useState } from 'react';
import Comment from 'services/comments/models/comments-interface';
import { EmptyBtn } from 'components/Buttons';
import { compareDate } from 'helpers/formatDate';

import {
  CommentCardContainer,
  CommentFormContainer,
  CommentBlankBtn,
} from '../style';
import CommentsIcon from 'assets/icon/icone-comentarios.svg';
import { User } from 'services/user/models/user-interface';

interface ICommentResponse {
  comment: Comment;
  handleCreateNewComment: (
    comment: string,
    id: string,
    response_id: string,
  ) => void;
  user: User;
  lessonId: string;
}

const ResponseContent: React.FC<ICommentResponse> = ({
  comment,
  handleCreateNewComment,
  user,
  lessonId,
}) => {
  const [responseText, setResponseText] = useState('');
  const [isResponding, setIsResponding] = useState<boolean>(false);

  const responseCleanup = () => {
    setResponseText('');
    setIsResponding(false);
  };

  const handleCancelBtnClick = () => {
    responseCleanup();
  };

  const handleSendBtnClick = () => {
    handleCreateNewComment(responseText, lessonId, comment.comment_id);
    responseCleanup();
  };

  return (
    <>
      <div className="btns-comment">
        {!isResponding && (
          <EmptyBtn
            onClick={() => {
              setIsResponding(true);
            }}
          >
            Responder
          </EmptyBtn>
        )}
      </div>

      {comment.responses && comment.responses.length ? (
        <div className="list-responses">
          {comment.responses.map((response, index) => (
            <CommentCardContainer key={index}>
              <div className="container">
                <div className="avatar-container">
                  <img
                    src={response.user_avatar_url}
                    alt="person"
                    className="profile-avatar"
                  />
                </div>

                <div className="comment-card">
                  <div className="title">
                    <h2>{response?.username}</h2>

                    <span>{compareDate(response?.created_at)}</span>
                  </div>

                  <p>{response?.description}</p>
                </div>
              </div>
            </CommentCardContainer>
          ))}
        </div>
      ) : null}
      {isResponding && (
        <CommentFormContainer isResponseComponent={true}>
          <div className="input-container">
            <textarea
              placeholder="Faça um comentário"
              value={responseText}
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                setResponseText(event.target.value)
              }
              rows={4}
            />
          </div>

          <div className="btns-container">
            <CommentBlankBtn onClick={handleSendBtnClick}>
              <img src={CommentsIcon} alt="comments" />
              Enviar comentário
            </CommentBlankBtn>
            <EmptyBtn onClick={handleCancelBtnClick}>Cancelar</EmptyBtn>
          </div>
        </CommentFormContainer>
      )}
    </>
  );
};

export default ResponseContent;
